"use client";

import { Button } from "@decibeltrade/web-core/components";
import { useTranslations } from "next-intl";

import { NetworkDownTooltip, useIsNetworkDown } from "@/contexts/health";

import { openWalletSelectorModal } from "../modal/wallet-selector-modal";

/**
 * A component that renders a button that opens a wallet selection modal.
 * When a wallet is connected, the button will open a menu that allows you to copy the
 * wallet address or disconnect the wallet.
 */
export function WalletSelector({ className }: { className?: string }) {
  const t = useTranslations("walletSelector");

  const triggerLabel = t("connectWallet");

  const isNetworkDown = useIsNetworkDown();

  return (
    <NetworkDownTooltip isNetworkDown={isNetworkDown}>
      <Button
        variant="secondary"
        onClick={openWalletSelectorModal}
        disabled={isNetworkDown}
        className={className}
      >
        {triggerLabel}
      </Button>
    </NetworkDownTooltip>
  );
}
